import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import { connect } from 'react-redux';
import { applicationActions } from '../../../../actions/applicationActions';
import { roleConstants } from '../../../../constants/roleConstants';
import { applicationConstants } from '../../../../constants/applicationConstants';

class ApplicationUnlockButton extends Component {
  render() {
    const { application, user, handleLock, cls } = this.props;

    return !application.loading &&
      application.is_locked &&
      application.status === applicationConstants.STATUS_ACTIVE &&
      user.role_id === roleConstants.ROLE_ADMIN ? (
      <Button className={cls} onClick={handleLock(application.id)}>
        Разблокировать
      </Button>
    ) : (
      ''
    );
  }
}

const mapStateToProps = state => {
  const { adminApplications } = state;

  return {
    adminApplications
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dispatch
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { dispatch } = dispatchProps;

  const handleLock = id => {
    return e => dispatch(applicationActions.unlock(id));
  };

  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,

    handleLock
  };
};

const connectedApplicationUnlockButton = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(ApplicationUnlockButton);
export { connectedApplicationUnlockButton as ApplicationUnlockButton };
